<p-card styleClass="p-card-content-fit">
    <!--Añadir Contacto-->
    <ng-template pTemplate="header">
        <div class="p-card-title">
            Reuniones
            <div class="p-card-title-actions">
                <a (click)="view(null)">
                    <fa-icon [icon]="['fas', 'plus-circle']"></fa-icon>Nueva reunión
                </a>
            </div>
        </div>
    </ng-template>
    <div class="p-grid">
        <!--Tabla de contacts-->
        <div class="p-col-12">
            <p-table #grid [value]="meetings" [lazy]="true" (onLazyLoad)="loadData($event)" [loading]="loading"
                [paginator]="true" [rows]="10" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
                currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                [rowsPerPageOptions]="[5,10,25,50]" paginatorDropdownAppendTo="body">
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="subject">Asunto</th>
                        <th pSortableColumn="from">Desde</th>
                        <th pSortableColumn="to">Hasta</th>
                        <th width="100"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-meeting>
                    <tr (dblclick)="view(meeting)">
                        <td>{{meeting.subject}}</td>
                        <td>{{meeting.from | date:'short'}}</td>
                        <td>{{meeting.to | date:'short'}}</td>
                        <td class="grid-actions">
                            <a (click)="view(meeting)">
                                <fa-icon [icon]="['far', 'edit']"></fa-icon>
                            </a>
                            <a (click)="delete(meeting)" class="color-danger">
                                <fa-icon [icon]="['far', 'trash-alt']"></fa-icon>
                            </a>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</p-card>
